<template ><section class="client">
  <div class="animated fadeInDown">
    <!-- <loader :isLoading="isLoading"></loader> -->
    <div class="row">
      <div class="col-md-12 mb-1">
        <b-tabs>
          <b-tab @click="" :title="$t('common.global')" class="show" active>
            <slaglobal></slaglobal>
          </b-tab>
          <b-tab @click="" :title="$t('common.client')" class="">
            <slaclient></slaclient>
       
          </b-tab>
        </b-tabs>
      </div>
    </div>

  </div>
</section></template>
<script >
import apiUrl from '../../../constants'
import axios from 'axios'


import slaglobal from '../SLA/slaglobal'
import slaclient from '../SLA/slaclient'

import CryptoJS from 'crypto-js'

export default {
	name: 'SLA',
	components: {
		slaglobal,
		slaclient
	
	},
	data() {
		return {
		
			
		}
	},
	computed: {},
	filters: {

	},
	
	filters: {	
	},
	methods: {


	} 

}

</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/components/SLA/index.vue?5de86d7c